import React from "react";
import style from "./SkillSection.module.css";
import starIcon from "./icons/slideshow_starr.png";
import badge2 from "./icons/Badge2.svg";
import { useQuery } from "@tanstack/react-query";
import { getSkillsList } from "../../api/containersApi";
import { useNavigate } from "react-router-dom";

function SkillSection({allowOuterShadow}) {

    const navigate = useNavigate();

    let {data: skillsList, isLoading, error} = useQuery({
        queryKey: ["skillsList"],
        queryFn: () => (getSkillsList(localStorage.getItem("sessionToken"))),
        // staleTime: 1000 * 60 * 5,
    });
    if(isLoading)
        return <div>Loading...</div>
    if(error){        
        skillsList = [ 'GoLang Developer', 'Business Analyst', 'API Technical Support', 'Digital Marketing', 'Data Analyst', 'Risk Analyst', 'Graphic Designer', 'Geographical Information System (GIS)',  'Remote Sensing (RS)', 'IT Sales', 'Pre-Sales - Cybersecurity', 'Renewal Business', 'A & R Manager', 'UI/UX Designer', 'Operations', 'Product Support', 'Learning and Development', 'Business Development', 'Subject Matter Experts', 'PHP/ Laravel Developer', 'Accounts', 'Investment Banking' ]
    }    

    // const SkillsData1 = [
    //     'GoLang Developer',
    //     'Business Analyst',
    //     'API Technical Support',
    //     'Digital Marketing',
    //     'Data Analyst',
    //     'Risk Analyst',
    //     'Graphic Designer',
    //     'Geographical Information System (GIS)', 
    //     'Remote Sensing (RS)',
    //     'IT Sales',
    //     'Pre-Sales - Cybersecurity',
    //     'Renewal Business',
    //     'A & R Manager',
    //     'UI/UX Designer',
    //     'Operations',
    //     'Product Support',
    //     'Learning and Development',
    //     'Business Development',
    //     'Subject Matter Experts',
    //     'PHP/ Laravel Developer',
    //     'Accounts',
    //     'Investment Banking',
    // ]
    // const SkillsData2 = [
    //     'L1/L2 Technical Support',
    //     'Product Manager',
    //     'Mobile App Architect',
    //     'Integration Lead',
    //     'Java Developer',
    //     'Devops Engineer',
    //     'Unity Developer',
    //     'React Native Developer',
    //     'VOIP (Voice over internet protocol) Developer',
    //     'Data Architect',
    //     'Informatica MDM Lead/ Architect',
    //     'Dotnet Developer',
    //     'PHP Developer',
    //     'IOS Developer',
    //     'Linux Admin',
    //     'Head of Engineering',
    //     'AI/ML Developer',
    //     'AEM Developer',
    //     'Content Writing',
    //     'CyberArk PAM',
    //     'SOC Expert',
    // ]
        
    return(

        <div className={`${allowOuterShadow && style.outerShadow} ${style.Skills_outerBorder}`}>
            <div className={style.Skills_container} data-aos="fade-up" data-aos-duration="1000" data-aos-offset="20">
                <p>Skills We've Secured and Counting</p>
                <p>
                    Unlocking success by recruiting a diverse range of skills, empowering innovation, and driving growth through every talent we bring on board.
                </p>

                <div className={style.Skills_slideshow}>
                    <div className={`${style.sliding_container} ${style.sliding_container_animation1}`}>
                        {
                            skillsList.slice(0, skillsList.length/2).map((skill) => { 
                                return <div><span>{skill["skill_name"]}</span> <img src={starIcon} alt="STAR" /></div>
                            })
                        }
                    </div>
                    <div className={`${style.sliding_container} ${style.sliding_container_animation1}`}>
                        {
                            skillsList.slice(0, skillsList.length/2).map((skill) => {
                                return <div><span>{skill["skill_name"]}</span> <img src={starIcon} alt="STAR" /></div>
                            })
                        }
                    </div>
                </div>
                <div className={style.Skills_slideshow} style={{marginBottom: "3rem"}}>
                    <div className={`${style.sliding_container} ${style.sliding_container_animation2}`}>
                        {
                            skillsList.slice(skillsList.length/2, skillsList.length).map((skill) => {
                                return <div><span>{skill["skill_name"]}</span> <img src={starIcon} alt="STAR" /></div>
                            })
                        }
                    </div>
                    <div className={`${style.sliding_container} ${style.sliding_container_animation2}`}>
                        {
                            skillsList.slice(skillsList.length/2, skillsList.length).map((skill) => {
                                return <div><span>{skill["skill_name"]}</span> <img src={starIcon} alt="STAR" /></div>
                            })
                        } 
                    </div>
                </div>
                
                {/* <a style={{border: "1px solid black", textAlign: "center"}} href=""> */}
                    <img 
                        onClick={() => {
                            window.open("https://www.designrush.com/agency/profile/nufolks", "_blank");
                        }}
                        className={style.badge1} 
                        src={badge2} 
                        alt="Badge" 
                    />
                {/* </a> */}
                {/* https://www.designrush.com/agency/profile/nufolks-global-pvt-ltd */}
            </div>
        </div>
    );
}

export default SkillSection;